export enum UserMessageLevel {
  Error = "error",
  Warn = "warn",
  Info = "info",
  Notice = "notice",
}

export enum UserMessageReplaceGroup {
  Authentication = "authentication",
  PriceSync = "price_sync",
}

export interface UserMessageOpts {
  dismiss?: boolean;
  dismissAfter?: number;
  userDismissable?: boolean;
  replaceGroup?: UserMessageReplaceGroup;
}

export interface UserMessage {
  id: string;
  title: string;
  body: string;
  createdAt: string;
  level: UserMessageLevel;
  dismissed: boolean;
  userDismissable: boolean;
  dismissAfter?: number;
  replaceGroup?: UserMessageReplaceGroup;
}

export interface SimpleUserMessage {
  title: string;
  body: string;
  level: UserMessageLevel;
  opts?: UserMessageOpts;
}
